module.exports = __webpack_public_path__ + "img/5s.29b9eb57.png";